<template>
  <div class="adjustmentlimit">
    <div
      class="adjustmentlimit-table"
      v-for="item in tableData"
      :key="item.coverageCode"
    >
      <a-table
        bordered
        size="small"
        :columns="columns"
        :data-source="item.conditionsNew"
        select-key="index"
        :pagination="false"
      >
        <template slot="ytdAmt" slot-scope="text">
          {{ moneyFormat(text) }}
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { moneyFormat } from '@/utils/index.js'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    // 给表格动态设置高度
    tableHeight(val) {
      const doms = document.querySelectorAll(
        '.condition-table .ant-table-body table'
      )
      if (doms) {
        doms.forEach(dom => {
          dom.style.height = val + 'px'
        })
      }
    }
  },
  data() {
    const columns = [
      {
        title: '责任名称',
        dataIndex: 'coverageCode',
        width: 100,
        customRender: (text, record, index) => {
          return {
            children: text,
            attrs: {
              rowSpan: index === 0 ? 100 : 0
            }
          }
        }
      },
      { title: '双重福利名称', dataIndex: 'limitDesc', width: 100 },
      {
        title: '已使用额度',
        dataIndex: 'ytdAmt',
        width: 100,
        scopedSlots: { customRender: 'ytdAmt' }
      },
      {
        title: '剩余额度',
        dataIndex: 'remAmt',
        width: 100,
        customRender: text => {
          return moneyFormat(text)
        }
      },
      {
        title: '总额度',
        dataIndex: 'conditions',
        width: 250
      }
    ]
    return {
      columns
    }
  },
  methods: {
    moneyFormat,
    // 表格样式处理
    rowRenderDeal() {
      return {
        style: {
          'background-color': '#fff'
        }
      }
    },
    // 获取双重理算消耗案件
    getItemYtdDetail(parentDate, record) {
      this.$emit('getItemYtdDetail', parentDate, record)
    }
  }
}
</script>
<style lang="less" scoped>
.adjustmentlimit-table {
  margin: 10px 5px;
  ::v-deep {
    .ant-table-thead tr th {
      background-color: #fafafa !important;
    }
    .ant-table-body {
      margin: 0;
    }
  }
}
</style>
